import { forwardRef } from "react";
import { DateInput } from "@mantine/dates";
import dayjs from "dayjs";
import useIsDesktop from "../../../hooks/useIsDesktop";

const CustomDateInput = forwardRef(
  (
    {
      labelProps = {
        style: { fontWeight: "700" },
        className: "text-neutral-500",
      },
      popoverProps,
      size,
      ...props
    },
    ref
  ) => {
    const isDesktop = useIsDesktop();
    const responsiveSize = size ?? (isDesktop ? "md" : "sm");
    const safePopoverProps = {
      position: "bottom",
      middlewares: { flip: false, shift: false },
      ...popoverProps,
    };

    return (
      <DateInput
        labelProps={labelProps}
        ref={ref}
        maxDate={dayjs().toDate()}
        clearable
        size={responsiveSize}
        popoverProps={safePopoverProps}
        {...props}
      />
    );
  }
);

export default CustomDateInput;
